import { Stack, styled, Typography } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { commonBorderLight } from 'themes';

export const StyledStack = styled(Stack)`
  max-width: 896px;
`;

export const StyledDataGridRowValue = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
  textTransform: 'capitalize',
  color: '#3C3445',
  whiteSpace: 'normal', // This allows the text to wrap onto the next line
  overflowWrap: 'break-word', // Breaks long words to prevent overflow
}));

export const StyledDataGrid = styled(DataGridPro)(() => ({
  '& .border-right': {
    borderRight: commonBorderLight,
  },

  '& .MuiDataGrid-cell': {
    padding: '12px 24px',
  },

  '& .MuiDataGrid-columnHeader': {
    padding: '8px 24px',
  },
  '& .MuiDataGrid-columnHeaders': {
    borderRadius: '8px 8px 0 0',
    borderBottom: commonBorderLight,
  },
}));
